/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-11-04 11:14:12
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

import { get, post } from 'src/api/http';
import types from './type.d';
import {TaskResult, ReturnPageData, TaskMess} from 'src/api/types';

class AbnormalMgnt {
    getNodeByLoginUser (subSysNo:string): Promise<types.NodeByLoginUserData[]> {
        return get('/business/common/iframe/node-login-user?subSysNo=' + subSysNo);
    }
    getMeterTypeList (dsit:string = ''): Promise<types.MeterTypeList[]> {
        return get('/amr/abnormal/meter-type-list?dsit=' + dsit);
    }
    getTaskByMeterType (meterType:string = ''): Promise<types.TaskByMeterTypeData[]> {
        return get('/amr/abnormal/task-meter-type?cstType=' + meterType);
    }
    getMeterList (data: types.MeterlistParams): Promise<ReturnPageData<types.MeterListData>> {
        return post('/amr/abnormal/getFrozenStatusByEs', data);
    }
    supplementaryData (data: types.SupDataParams): Promise<TaskResult> {
        return post('/amr/abnormal/supplementary-data', data);
    }
    getTaskGroup (data:types.TaskGroupListParams):Promise<types.TaskGroupModuleData[]> {
        return get('/amr/abnormal/schedule-task-group-by-module', data);
    }
    getTaskList (data: types.TaskListParams): Promise<ReturnPageData<types.TaskListRows>> {
        return get('/amr/abnormal/schedule-task-list-by-group', data);
    }
    resetTask (data:types.ResetTaskParams):Promise<TaskMess> {
        return post('/amr/abnormal/reset-task', data);
    }
    createMakeUpTask (data: types.MeterListData[]): Promise<types.ResultTask> {
        return post('/amr/abnormal/create-virtual-task', {
            meterInfo: JSON.stringify(data),
        });
    }
    supplementaryCopyStrategy (): Promise<types.SupCopyStrategyData> {
        return get('/amr/abnormal/supplementaryCopyStrategy');
    }
    taskRuleObis (): Promise<types.TaskRuleObisData[]> {
        return get('/amr/abnormal/taskRuleObis');
    }
    stopTask (): Promise<string|boolean> {
        return post('/amr/abnormal/stopTask');
    }
    startTask (): Promise<string|boolean> {
        return post('/amr/abnormal/startTask');
    }
    updateSupplementaryCopyStrategy (data:types.SupCopyStrategyData): Promise<string|boolean> {
        return post('/amr/abnormal/updateSupplementaryCopyStrategy', data);
    }
    getMakeUpPolicy ():Promise<types.QueryMakeUpPolicy> {
        return get('/amr/abnormal/getMakeUpPolicy');
    }
    updateMakeUpPolice (data:types.QueryMakeUpPolicy) {
        return post('/amr/abnormal/updateMakeUpPolice', data);
    }
    importPushData (fileId:string) {
        return get('/amr/abnormal/import-push-data', {fileId});
    }
    getAbnormalMeter (data: types.QueryAbnormalMeterParams): Promise<ReturnPageData<types.QueryAbnormalMeterRows>> {
        return get('/amr/abnormal/abnormal-meter-list', data);
    }
    orderAbnormalMeter (data: types.OrderAbnormalMeterParams[]): Promise<boolean> {
        return post('/amr/abnormal/dispatch-order-operation', data);
    }
    getMeterTask (data: types.MeterTaskParams): Promise<ReturnPageData<types.MeterTaskRows>> {
        return post('/amr/abnormal/get-reading-task', data);
    }
    getReadTaskGroup (data: types.TaskGroupListParams): Promise<types.TaskGroupModuleData[]> {
        return get('/amr/abnormal/reading-task-group', data);
    }
    getDeviceCaptureList (data: types.QueryDeviceCaptureListParams): Promise<types.QueryDeviceCaptureListRows[]> {
        return get('/amr/capture/device-capture-list', data);
    }
}

export default new AbnormalMgnt();
